import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Helmet, translate} from 'views/module';
import DashboardView from 'views/scenes/dashboard/DashboardView';

const App = (props) => {
  return (
    <>
      <Helmet>
        <title>{translate('dashboard.Helmet.title')}</title>
      </Helmet>
      <DashboardView />
    </>
  );
};

App.propTypes = {
  clientRn: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  clientRn: state.user.clientRn,
});

export default connect(mapStateToProps, dispatch)(App);
